<template>
  <ValidationObserver ref="formTracking" novalidate>
    <form novalidate @submit.prevent="save">
      <div class="ml-2 mr-2 mt-n3">
        <CustomCollapse id="addTracking" class="mt-2">
          <CustomCollapseItem
            parent-id="addTracking"
            title="Añadir Seguimiento"
            :selected="true"
            expanded
            class="badge-modal-custom"
          >
            <div class="row ml-4">
              <div class="ml-3">
                <ValidationProvider v-slot="{ errors }" rules="required">
                  <CustomDatePicker
                    v-model="info.date"
                    label="Fecha:"
                    placeholder="DD/MM/YYYY"
                    class="w-80"
                    :error="errors[0]"
                    custom-error-msg="Campo requerido."
                    :max-date="new Date()"
                    :disabled="isEditMode"
                  />
                </ValidationProvider>
              </div>
            </div>
            <div class="row mt-4 ml-4">
              <div class="col-md-12">
                <ValidationProvider v-slot="{ errors }" rules="required">
                  <CustomTextArea
                    v-model="info.description"
                    label="Añadir Comentario: "
                    :maxlength="500"
                    :row="5"
                    :error="errors[0]"
                    custom-error-msg="Campo requerido."
                  />
                </ValidationProvider>
              </div>
            </div>
            <div class="row">
              <div class="col text-right">
                <ActionButton
                  i="fas fa-times-circle"
                  variant="outline-danger btn-cancel danger m-2"
                  @click="cancel"
                >
                  Cancelar
                </ActionButton>
                <ActionButton
                  v-if="!isEditMode"
                  variant="success m-2 pl-4 pr-4"
                  type="submit"
                >
                  Añadir
                </ActionButton>
                <ActionButton
                  v-if="isEditMode"
                  i="fas fa-save"
                  variant="success m-2 pl-4 pr-4"
                  type="submit"
                >
                  Guardar
                </ActionButton>
              </div>
            </div>
          </CustomCollapseItem>
        </CustomCollapse>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import {
  CustomDatePicker,
  ActionButton,
  CustomTextArea,
} from '@/components/common';
import CustomCollapse from '@/components/common/CustomCollapse';
import CustomCollapseItem from '@/components/common/CustomCollapseItem';
import { ValidationObserver, ValidationProvider } from 'vee-validate';

export default {
  name: 'TrackingInformationAdd',
  data() {
    return {
      info: {
        date: null,
        description: '',
      },
    };
  },
  computed: {
    isEditMode() {
      return this.comment ? true : false;
    },
  },
  props: {
    comment: {
      type: Object,
      default: () => null,
    },
  },
  methods: {
    cancel() {
      this.$emit('on-cancel');
    },
    async save() {
      const isValid = await this.$refs.formTracking.validate();
      this.$emit('on-save', isValid ? { ...this.info } : null, this.isEditMode);
    },
  },
  mounted() {
    if (this.comment) {
      this.info = this.comment;
    }
  },
  components: {
    ActionButton,
    CustomDatePicker,
    CustomCollapse,
    CustomCollapseItem,
    ValidationObserver,
    ValidationProvider,
    CustomTextArea,
  },
};
</script>

<style scoped>
.badge-modal-custom >>> .tag-badge-title {
  font-size: 20px;
}

.badge-modal-custom >>> .tag-badge-pei {
  margin-left: -10px;
}
.danger-text {
  color: #e85c5c;
}
</style>
